<template>
	<div class="cloud-Personnel">
		<ul class="cloud-Personnel-ul">
			<li>
				<div id="main_Personnel1" class="chart-container"></div>
				<div>
					<p>{{ FormData.tunnel.toFixed(0) }}</p>
					<p>隧道数量</p>
				</div>
			</li>
			<li>
				<div id="main_Personnel2" class="chart-container"></div>
				<div>
					<p>{{ FormData.worker.toFixed(0) }}</p>
					<p>人员数量</p>
				</div>
			</li>
			<li>
				<div id="main_Personnel3" class="chart-container"></div>
				<div>
					<p>{{ FormData.car.toFixed(0) }}</p>
					<p>车辆数量</p>
				</div>
			</li>
			<li>
				<div id="main_Personnel4" class="chart-container"></div>
				<div>
					<p>{{ FormData.environment.toFixed(0) }}</p>
					<p>设备数量</p>
				</div>
			</li>
		</ul>
		<!-- 移除固定高度，由CSS控制 -->

	</div>
</template>

<script>
import * as echarts from 'echarts';
import { getstatisticsMultipleItemCount } from '@/public/api.js'
import { PersonnelData } from '../testData/PersonnelData'

export default {
	name: 'Personnel',
	data() {
		return {
			myChart1: null,
			myChart2: null,
			myChart3: null,
			myChart4: null,
			FormData: {
				environment: 0,
				environmentDay: 0,
				worker: 0,
				workerDay: 0,
				car: 0,
				carDay: 0,
				tunnel: 0,
				tunnelNum: 0,
			}
		}
	},
	mounted() {
		this.statisticsMultipleItemCount();
		// 监听窗口大小变化，自动调整图表
		window.addEventListener('resize', this.handleResize);
	},
	methods: {
		// 统计多个项目数量
		statisticsMultipleItemCount() {
			let that = this;
			getstatisticsMultipleItemCount({}).then(res => {
				if (res.data.code == 200) {
					let dataDom = res.data.data;

					let hostName = window.location.hostname;

					if (hostName == '127.0.0.1' || hostName == '39.100.79.198' || hostName == 'sd.yongsixinxi.com') {
						dataDom = PersonnelData();
					}

					that.FormData = {
						environment: dataDom.deviceCount,
						environmentDay: dataDom.deviceCount * 0.1 + Math.random() * 0.8000000001,
						worker: dataDom.personCount,
						workerDay: dataDom.personCount * 0.1 + Math.random() * 0.8000000001,
						car: dataDom.carCount ,
						carDay: dataDom.carCount * 0.1 + Math.random() * 0.8000000001,
						tunnel: dataDom.tunnelCount ,
						tunnelNum: dataDom.tunnelCount * 0.1 + Math.random() * 0.8000000001,
					}

					// 初始化图表
					this.myChart1 = echarts.init(document.getElementById('main_Personnel1'));
					this.initChart(this.myChart1, [that.FormData.tunnel, that.FormData.tunnelNum], '#FFB642');

					this.myChart2 = echarts.init(document.getElementById('main_Personnel2'));
					this.initChart(this.myChart2, [that.FormData.worker, that.FormData.workerDay], '#69D4AA');

					this.myChart3 = echarts.init(document.getElementById('main_Personnel3'));
					this.initChart(this.myChart3, [that.FormData.car, that.FormData.carDay], '#EE605E');

					this.myChart4 = echarts.init(document.getElementById('main_Personnel4'));
					this.initChart(this.myChart4, [that.FormData.environment, that.FormData.environmentDay], '#E96BFD');

				}
			})
		},
		initChart(myChart, data, color) {
			const option = {
				legend: {
					right: '30%',
					top: 'center',
					orient: 'vertical',
					data: [],
					textStyle: {
						color: '#333',
						fontSize: 12 // 缩小字体避免占用过多空间
					},
					itemWidth: 8,  // 缩小图例标记
					itemHeight: 8,
					itemGap: 8     // 减小图例项间距
				},
				toolbox: {
					show: false
				},
				series: [
					{
						type: 'pie',
						center: ['15%', '60%'], // 调整位置避免超出
						radius: ['50%', '80%'], // 使用百分比半径，自适应容器
						itemStyle: {
							normal: {
								label: {
									show: false,
								}
							},
						},
						data: [
							{
								name: 'other',
								value: data[0],
								itemStyle: {
									normal: {
										color: color,
										label: {
											show: true,
											position: 'center',
											textStyle: {
												color: '#999',
												fontSize: 12 // 缩小文字
											}
										},
										labelLine: {
											show: false
										}
									},
									emphasis: {
										color: 'rgba(0,0,0,0)'
									}
								}
							},
							{
								name: 'GoogleMaps',
								value: data[1],
								itemStyle: {
									normal: {
										color: '#333',
										label: {
											show: true,
											position: 'center',
											formatter: '{b}',
											textStyle: {
												baseline: 'bottom',
												fontSize: 12,
												color: '#333'
											}
										},
										labelLine: {
											show: false
										}
									}
								}
							}
						]
					}
				]
			};

			myChart.setOption(option);
		},
		// 窗口大小变化时调整图表
		handleResize() {
			if (this.myChart1) {
				this.myChart1.resize();
			}
			if (this.myChart2) {
				this.myChart2.resize();
			}
			if (this.myChart3) {
				this.myChart3.resize();
			}
			if (this.myChart4) {
				this.myChart4.resize();
			}
		}
	},
	beforeDestroy() {
		// 移除事件监听，销毁图表
		window.removeEventListener('resize', this.handleResize);
		if (this.myChart1) {
			this.myChart1.dispose();
		}
		if (this.myChart2) {
			this.myChart2.dispose();
		}
		if (this.myChart3) {
			this.myChart3.dispose();
		}
		if (this.myChart4) {
			this.myChart4.dispose();
		}
	}
}
</script>
<style scoped>
.cloud-Personnel {
	width: 100%;
	/* 确保父容器有明确高度 */
	height: 10vh;
	/* 适当增加高度，容纳图表和图例 */
	text-align: left;
	position: relative;

	>.cloud-Personnel-ul {
		list-style: none;
		margin: 0;
		padding: 0;

		>li {
			width: 100%;
			height: 9vh;
			position: relative;
			border-bottom: 1px solid #4d4949;
			padding-bottom: 1vh;

			>div:nth-child(2) {
				width: 50%;
				height: 100%;
				position: absolute;
				left: 7vw;
				top: 0;

				>p {
					margin: 0px;
					padding: 0px;

					&:nth-child(1) {
						font-size: 1.6vw;
						font-weight: 400;
						margin-top: 2.0vh;
					}

					&:nth-child(2) {
						font-size: 0.8vw;
					}
				}
			}
		}
	}
}

/* 图表容器样式 */
.chart-container {
	width: 100%;
	height: 100%;
	/* 设置最小高度，避免过小 */
	box-sizing: border-box;
	padding: 5px;
	/* 增加内边距，避免内容贴边 */
}
</style>